import { EditNotificationsOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { DataGrid, GridDeleteIcon } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import Header from "../../components/Header";
import ActionApi from "../../services/api/actions";
import { tokens } from "../../theme";
import ActionForm from "./form";
import useMediaQuery from "hooks/useMediaQuery";

const Actions = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const actionModule = ActionApi();
  const [actionList, setActionList] = useState([]);

  const [isConfirmationOpen, setConfirmationOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [editingData, setEditingData] = useState();

  const [open, setOpen] = useState(false);

  const isSmallScreen = useMediaQuery("(max-width: 767px)");

  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "",
      headerName: "Action",
      width: 200,
      renderCell: ({ row: { id } }) => {
        return (
          <Box
            display="flex"
            gap={2}
            justifyContent="center"
            borderRadius="4px"
          >
            <Box display="flex">
              <EditOutlinedIcon
                fontSize="small"
                style={{ marginRight: "4px" }}
              />
              <Typography
                variant="button"
                color="warning"
                onClick={() => editAction(id)}
                style={{ cursor: "pointer", marginRight: "10px" }}
              >
                Edit
              </Typography>
            </Box>

            <Box display="flex">
              <DeleteOutlineOutlinedIcon
                fontSize="small"
                color="error"
                style={{ marginRight: "4px" }}
              />
              <Typography
                variant="button"
                color="error"
                onClick={() => deleteAction(id)}
                style={{ cursor: "pointer" }}
              >
                Delete
              </Typography>
            </Box>
          </Box>
        );
      },
    },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const data = await actionModule.getAll();

      setActionList(data.results);
    } catch (error) {
      console.log(fetchErrorMsg, error);
    }
  };

  const editAction = (id) => {
    const action = actionList.find((row) => row.id === id);
    setEditingData(action);
    viewForm();
  };

  const deleteAction = (id) => {
    setSelectedId(id);
    handleOpenConfirmation();
  };

  const handleOpenConfirmation = () => {
    setConfirmationOpen(true);
  };

  const handleCloseConfirmation = () => {
    setConfirmationOpen(false);
  };

  const handleConfirmAction = () => {
    try {
      const response = actionModule.destroy(selectedId);

      console.log(deletedSuccessMsg, response);
      fetchData();
    } catch (error) {
      console.log(deleteErrorMsg, error);
    }

    handleCloseConfirmation();
  };

  const createAction = () => {
    setEditingData();
    viewForm();
  };

  const viewForm = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    fetchData();
  };

  return (
    <>
      <Box
        gap={2}
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "15px 30px",
          borderBottom: "1px solid var(--color-primary-200)",
        }}
      >
        <Header title="Actions" />
        <Box sx={{ borderLeft: "1px solid var(--color-primary-200)" }}>
          <Button
            type="submit"
            variant="text"
            onClick={createAction}
            sx={{ padding: "5px 15px" }}
            startIcon={<AddIcon />}
          >
            Create Action
          </Button>
        </Box>
      </Box>

      <Box m="30px" display="flex" flexDirection="column" flex={1}>
        <Box
          sx={{
            height: {
              xs: "100%",
              sm: 300,
              md: "calc(100vh - 65px - 50px - 60px)",
            },
          }}
        >
          <DataGrid
            rows={actionList}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            columnHeaderHeight={isSmallScreen ? 70 : 60}
            sx={{
              "& .MuiDataGrid-columnHeader--moving": {
                backgroundColor: "inherit !important",
              },
              ...(isSmallScreen && {
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                "& .MuiDataGrid-sortIcon": {
                  display: "none",
                },
                "& .MuiDataGrid-menuIcon": {
                  display: "none",
                },
                "& .MuiDataGrid-columnHeader": {
                  padding: "4px !important",
                  justifyContent: "center",
                  alignItems: "center",
                },
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  padding: "0 !important",
                  margin: "0 !important",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal !important",
                  wordBreak: "normal",
                  textAlign: "center",
                  lineHeight: 1.2,
                },
              }),
            }}
          />
        </Box>
      </Box>

      <ConfirmationDialog
        open={isConfirmationOpen}
        onClose={handleCloseConfirmation}
        onConfirm={handleConfirmAction}
      />

      <ActionForm
        formData={editingData}
        open={open}
        handleClose={() => handleClose()}
      />
    </>
  );
};

const deletedSuccessMsg = "Action deleted successfully: ";
const deleteErrorMsg = "Not deleted action. ";
const fetchErrorMsg = "Not loading actions";

export default Actions;
